import { render } from "./SearchBar.vue?vue&type=template&id=685aac4c"
import script from "./SearchBar.vue?vue&type=script&lang=js"
export * from "./SearchBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/HistoricalData/FeedbackPage/components/SearchBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "685aac4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('685aac4c', __exports__)) {
    api.reload('685aac4c', __exports__)
  }
  
  module.hot.accept("./SearchBar.vue?vue&type=template&id=685aac4c", () => {
    api.rerender('685aac4c', render)
  })

}


export default __exports__